import { render } from "./StaffPage_userCheck.vue?vue&type=template&id=255e886e&scoped=true"
import script from "./StaffPage_userCheck.vue?vue&type=script&lang=js"
export * from "./StaffPage_userCheck.vue?vue&type=script&lang=js"

import "./StaffPage_userCheck.vue?vue&type=style&index=0&id=255e886e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255e886e"]])

export default __exports__